import styled from "styled-components";
import {HomePageHeaderArenasContainerDefaultBox} from "./home-page-header-arenas-container.default.box";

export const HomePageHeaderArenasContainerWsopBox = styled(HomePageHeaderArenasContainerDefaultBox)`
  margin-bottom: 1.5rem;
  @media ${({theme}) => theme.mediaQuery.lAndAbove} {
    padding-top: 2.8rem;
    margin-bottom: 2rem;
  }
`;
